// components/UI.jsx — Shared reusable components
import { useState, useEffect, useRef } from 'react';

// ─── Icons (inline SVG to avoid dependency) ───────────────────────────────
export const Icons = {
  check: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  x: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  plus: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  copy: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="4.5" y="4.5" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5"/><path d="M1.5 8.5V2.5a1 1 0 011-1h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  download: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 1.5v7M3.5 6l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M1.5 10.5h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  trash: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1.5 3.5h10M4.5 3.5V2h4v1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M2.5 3.5l.7 7.5a1 1 0 001 .9h4.6a1 1 0 001-.9l.7-7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  search: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="6" cy="6" r="4" stroke="currentColor" strokeWidth="1.5"/><path d="M11 11l-2.5-2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  chevronRight: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4 2l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  chevronDown: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  upload: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 9V2M4 5l3-3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M1.5 10.5v1a1 1 0 001 1h9a1 1 0 001-1v-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  file: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 1.5h5.5L11 4v8.5a1 1 0 01-1 1H3a1 1 0 01-1-1v-10a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.5"/><path d="M8 1.5V4.5h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  warning: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1L13 12H1L7 1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M7 5.5v3M7 10.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  info: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5"/><path d="M7 6.5v3M7 4.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  check_circle: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5"/><path d="M4.5 7l2 2 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  moon: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.5 8.5A5.5 5.5 0 014 1.5a5.5 5.5 0 100 11 5.5 5.5 0 007.5-4z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  sun: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M7 1v1.5M7 11.5V13M1 7h1.5M11.5 7H13M3 3l1 1M10 10l1 1M3 11l1-1M10 4l1-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  menu: () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  drag: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="4" cy="3" r="1" fill="currentColor"/><circle cx="8" cy="3" r="1" fill="currentColor"/><circle cx="4" cy="6" r="1" fill="currentColor"/><circle cx="8" cy="6" r="1" fill="currentColor"/><circle cx="4" cy="9" r="1" fill="currentColor"/><circle cx="8" cy="9" r="1" fill="currentColor"/></svg>,
  send: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.5 1.5L1.5 6.5l4 1.5 2 4 5-10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M5.5 8l3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  sparkle: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.5l1.2 3.5 3.5 1.2-3.5 1.2L7 10.9l-1.2-3.5L2.3 6.2l3.5-1.2L7 1.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>,
  refresh: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M11.5 6.5A5 5 0 112.3 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M2 1v3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  external: () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M7 1h4v4M11 1L5.5 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 3H2a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  chart: () => <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1.5 12.5v-8l4-2 3 4 4-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  clock: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="6.5" r="5" stroke="currentColor" strokeWidth="1.5"/><path d="M6.5 4v3l2 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  edit: () => <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M9 2l2 2L4.5 10.5l-3 .5.5-3L9 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
};

// ─── Spinner ──────────────────────────────────────────────────────────────
export function Spin({ size = '', color = '' }) {
  return <div className={`spin ${size ? 'spin-'+size : ''} ${color ? 'spin-'+color : ''}`} />;
}

// ─── Loading Row ──────────────────────────────────────────────────────────
export function LoadRow({ msg = 'Processing…' }) {
  return (
    <div className="loading-row">
      <Spin />
      <span>{msg}</span>
    </div>
  );
}

// ─── Debounced Input Field ────────────────────────────────────────────────
export function Field({ label, value, onChange, placeholder, type = 'text', rows, autoTag, style, className, required, hint, monospace }) {
  const [local, setLocal] = useState(value ?? '');
  const timerRef = useRef(null);

  useEffect(() => {
    setLocal(value ?? '');
  }, [value]);

  function handleChange(e) {
    const v = e.target.value;
    setLocal(v);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(v), 300);
  }

  return (
    <div className={`form-field ${className || ''}`} style={style}>
      {label && (
        <label>
          {label}
          {required && <span style={{ color: 'var(--red-500)', marginLeft: 2 }}>*</span>}
          {autoTag && <span className="auto-tag">auto</span>}
        </label>
      )}
      {rows
        ? <textarea
            value={local}
            onChange={handleChange}
            placeholder={placeholder}
            rows={rows}
            style={monospace ? { fontFamily: 'var(--font-mono)', fontSize: 12 } : undefined}
          />
        : <input
            type={type}
            value={local}
            onChange={handleChange}
            placeholder={placeholder}
            style={monospace ? { fontFamily: 'var(--font-mono)', fontSize: 12 } : undefined}
          />
      }
      {hint && <span style={{ fontSize: 11, color: 'var(--slate-400)' }}>{hint}</span>}
    </div>
  );
}

// ─── Select Field ─────────────────────────────────────────────────────────
export function Select({ label, value, onChange, children, autoTag, style, className, hint }) {
  return (
    <div className={`form-field ${className || ''}`} style={style}>
      {label && (
        <label>
          {label}
          {autoTag && <span className="auto-tag">auto</span>}
        </label>
      )}
      <select value={value ?? ''} onChange={e => onChange(e.target.value)}>
        {children}
      </select>
      {hint && <span style={{ fontSize: 11, color: 'var(--slate-400)' }}>{hint}</span>}
    </div>
  );
}

// ─── Callout ──────────────────────────────────────────────────────────────
export function Callout({ type = 'blue', children, icon, onClose }) {
  const Icon = icon || ({
    blue: Icons.info,
    green: Icons.check_circle,
    red: Icons.warning,
    orange: Icons.warning,
    gold: Icons.info,
    teal: Icons.check_circle,
  }[type] || Icons.info);

  return (
    <div className={`callout callout-${type}`}>
      <span className="callout-icon"><Icon /></span>
      <div style={{ flex: 1 }}>{children}</div>
      {onClose && (
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: .6, padding: 0, display: 'flex' }}>
          <Icons.x />
        </button>
      )}
    </div>
  );
}

// ─── Toast System ─────────────────────────────────────────────────────────
let _addToast = null;

export function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    _addToast = (message, type = 'default', duration = 3500) => {
      const id = Date.now() + Math.random();
      setToasts(p => [...p, { id, message, type }]);
      setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), duration);
    };
    return () => { _addToast = null; };
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {t.type === 'success' && <Icons.check_circle />}
          {t.type === 'error' && <Icons.warning />}
          {t.type === 'warn' && <Icons.warning />}
          {t.type === 'info' && <Icons.info />}
          <span>{t.message}</span>
          <button onClick={() => setToasts(p => p.filter(x => x.id !== t.id))}
            style={{ background: 'none', border: 'none', cursor: 'pointer', marginLeft: 'auto', opacity: .6, color: 'inherit', padding: 0, display: 'flex' }}>
            <Icons.x />
          </button>
        </div>
      ))}
    </div>
  );
}

export function toast(message, type = 'default', duration) {
  if (_addToast) _addToast(message, type, duration);
  else console.log('[Toast]', message);
}

toast.success = (m, d) => toast(m, 'success', d);
toast.error   = (m, d) => toast(m, 'error', d);
toast.warn    = (m, d) => toast(m, 'warn', d);
toast.info    = (m, d) => toast(m, 'info', d);

// ─── Modal Wrapper ────────────────────────────────────────────────────────
export function Modal({ title, subtitle, onClose, children, size = '', footer }) {
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`modal modal-${size}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <div className="modal-title">{title}</div>
            {subtitle && <div className="modal-subtitle">{subtitle}</div>}
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {children}
        {footer && <div className="btn-row">{footer}</div>}
      </div>
    </div>
  );
}

// ─── Confirm Dialog ───────────────────────────────────────────────────────
export function Confirm({ title, message, onConfirm, onCancel, confirmLabel = 'Confirm', danger = false }) {
  return (
    <Modal title={title} onClose={onCancel}>
      <p style={{ fontSize: 13.5, color: 'var(--slate-600)', lineHeight: 1.6, marginBottom: 'var(--sp-5)' }}>{message}</p>
      <div className="btn-row">
        <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm}>{confirmLabel}</button>
        <button className="btn btn-ghost" onClick={onCancel}>Cancel</button>
      </div>
    </Modal>
  );
}

// ─── Output Panel with copy/save actions ─────────────────────────────────
// Lightweight markdown → HTML renderer, shared across tabs that need to
// display Penny output containing #/##/** markdown formatting as actual
// headers/bold text instead of literal characters.
export function renderMd(text) {
  if (!text) return '';
  const html = text
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/^### (.+)$/gm, '<h4 style="font-size:12px;font-weight:700;color:var(--navy-700);margin:14px 0 4px">$1</h4>')
    .replace(/^## (.+)$/gm,  '<h3 style="font-size:13px;font-weight:700;color:var(--navy-800);margin:16px 0 5px;border-bottom:1px solid var(--slate-200);padding-bottom:4px">$1</h3>')
    .replace(/^# (.+)$/gm,   '<h2 style="font-size:14px;font-weight:700;color:var(--navy-900);margin:0 0 12px">$1</h2>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g,     '<em>$1</em>')
    .replace(/^[-–] (.+)$/gm, '<div style="display:flex;gap:6px;margin:2px 0"><span style="color:var(--slate-400);flex-shrink:0">•</span><span>$1</span></div>')
    .replace(/^\d+\. (.+)$/gm, '<div style="margin:2px 0">$1</div>')
    .replace(/\*\((.+?)\)\*/g, '<span style="font-size:11px;color:var(--slate-400);font-style:italic">($1)</span>')
    .replace(/\n\n/g, '<div style="margin-top:8px"></div>')
    .replace(/\n/g, '<br>');
  return html;
}

export function OutputPanel({ label, content, onCopy, onSave, onExport, loading, loadMsg, markdown }) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    navigator.clipboard.writeText(content);
    setCopied(true);
    toast.success('Copied to clipboard');
    setTimeout(() => setCopied(false), 2000);
  }

  if (loading) return <LoadRow msg={loadMsg || 'Drafting…'} />;
  if (!content) return null;

  return (
    <div className="out-panel" style={{ marginTop: 12 }}>
      <div className="out-header">
        <span className="out-label">{label}</span>
        <div className="out-actions">
          {onExport && (
            <button className="btn btn-xs btn-ghost" onClick={onExport}>
              <Icons.download /> RTF
            </button>
          )}
          {onSave && (
            <button className="btn btn-xs btn-ghost" onClick={onSave}>
              Save to Vault
            </button>
          )}
          <button className="btn btn-xs btn-ghost" onClick={handleCopy}>
            {copied ? <Icons.check /> : <Icons.copy />}
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>
      </div>
      {markdown
        ? <div className="out-body" dangerouslySetInnerHTML={{ __html: renderMd(content) }} />
        : <div className="out-body">{content}</div>}
    </div>
  );
}

// ─── Empty State ──────────────────────────────────────────────────────────
export function EmptyState({ icon = '📄', title, subtitle, action }) {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <div className="empty-title">{title}</div>
      {subtitle && <p className="empty-sub">{subtitle}</p>}
      {action}
    </div>
  );
}

// ─── Section Label ────────────────────────────────────────────────────────
export function SectionLabel({ children }) {
  return <div className="section-label">{children}</div>;
}

// ─── Upload Zone ──────────────────────────────────────────────────────────
export function UploadZone({ file, onFile, accept = '.pdf', loading, title, subtitle, loaded, style }) {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  function handleDrop(e) {
    e.preventDefault();
    setDragging(false);
    const f = e.dataTransfer.files[0];
    if (f) processFile(f);
  }

  function processFile(f) {
    const reader = new FileReader();
    reader.onload = ev => onFile({ name: f.name, base64: ev.target.result.split(',')[1], size: f.size });
    reader.readAsDataURL(f);
  }

  const isLoaded = loaded || (file && file.base64);

  return (
    <div
      className={`upload-zone ${isLoaded ? 'loaded' : ''} ${dragging ? 'dragging' : ''}`}
      style={style}
      onClick={() => inputRef.current?.click()}
      onDragOver={e => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={e => { if (e.target.files[0]) processFile(e.target.files[0]); e.target.value = ''; }}
      />
      {loading
        ? <LoadRow msg="Reading file…" />
        : isLoaded
          ? <>
              <div className="upload-zone-title">✓ {file?.name || 'File loaded'}</div>
              <div className="upload-zone-sub">Click to replace</div>
            </>
          : <>
              <div className="upload-zone-title">{title || 'Click or drag file here'}</div>
              <div className="upload-zone-sub">{subtitle || 'Accepts PDF'}</div>
            </>
      }
    </div>
  );
}

// ─── Badge ────────────────────────────────────────────────────────────────
export function Badge({ children, color = 'gray', style }) {
  return <span className={`badge badge-${color}`} style={style}>{children}</span>;
}

// ─── Autosave Indicator ───────────────────────────────────────────────────
export function AutosaveIndicator({ status }) {
  const labels = { idle: 'Saved', saving: 'Saving…', error: 'Save failed' };
  const type = status === 'saving' ? 'saving' : status === 'error' ? 'error' : '';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'var(--slate-400)' }}>
      <div className={`autosave-dot ${type}`} />
      {labels[status] || 'Saved'}
    </div>
  );
}
